export default "__VITE_ASSET__DiG9I84J__"